<template>
  <div id="homeManage">
    我是手机页面的
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
}
</script>

<style lang="less" scoped>

</style>